import { MagpieConnection } from 'magpie-lib/connection';
import { Tags } from 'magpie-types/tags';
import { getPortalId } from '../../../common/utils';
import { useRef } from 'react';
import { Logger } from 'simple-logging-lib';
import { PLATFORM_LOGGER } from '../../../config';
const isDebugEnabled = () => {
  try {
    return localStorage.getItem('NAVIGATION_MAGPIE_DEBUG') === 'true';
  } catch (e) {
    return false;
  }
};
const hasExistingConnection = () => {
  try {
    return MagpieConnection.get() !== undefined;
  } catch (e) {
    return false;
  }
};
export const useSetupMagpie = platformName => {
  const wasCalled = useRef(false);
  if (wasCalled.current || hasExistingConnection()) {
    return;
  }
  try {
    MagpieConnection.create({
      tags: [Tags.NAV],
      portalId: getPortalId(),
      debug: isDebugEnabled(),
      appName: platformName
    });
    wasCalled.current = true;
  } catch (e) {
    const error = new Error('Failed to create Magpie connection for Navigation Components', {
      cause: e
    });
    const logger = Logger.getLogger(PLATFORM_LOGGER);
    logger.error(error);
  }
};